import { render, staticRenderFns } from "./members-professional-categories.html?vue&type=template&id=4a34dbb6&scoped=true&external"
import script from "./members-professional-categories.js?vue&type=script&lang=js&external"
export * from "./members-professional-categories.js?vue&type=script&lang=js&external"
import style0 from "./members-professional-categories.scss?vue&type=style&index=0&id=4a34dbb6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a34dbb6",
  null
  
)

export default component.exports